module.exports = __webpack_public_path__ + "static/img/CC4.478d9d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC4.png
// module id = Obhw
// module chunks = 0